export const initialFilterValues = {
  BusinessUnitId: [],
  LabeledFamilyId: [],
  MaterialGroupId: [],
  StockStatus: [],
  _page: 0,
  _size: 10,
}
